var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page container", attrs: { id: "area-chooser" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2",
          },
          [
            _c("div", { staticClass: "welcome card card-borderless" }, [
              _c("div", { staticClass: "user-details row" }, [
                _c("h2", [_vm._v(_vm._s(_vm.user.name))]),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(this.currentProgress.level.name))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-score row" }, [
                _c("div", { staticClass: "score-column col-xs-4" }, [
                  _c(
                    "div",
                    { staticClass: "number" },
                    [
                      _vm._v(
                        "\n              " + _vm._s(_vm.completeCategoriesCount)
                      ),
                      _c("slash", { staticStyle: { margin: "0 4px" } }),
                      _c("span", { staticClass: "all-count" }, [
                        _vm._v(_vm._s(_vm.allCategoriesCount)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "description svg-line" },
                    [
                      _c("check-badge", { staticClass: "svg-icon" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("AREA_CHOOSER_COMPLETE_COURSES")
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "vertical-divider",
                  staticStyle: { height: "61px" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "score-column col-xs-4" }, [
                  _c("div", { staticClass: "number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.allAreasAchievementsCount) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "description svg-line" },
                    [
                      _c("trophy", { staticClass: "svg-icon" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("AREA_CHOOSER_ACHIEVEMENTS_COUNT")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "vertical-divider",
                  staticStyle: { height: "61px" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "score-column col-xs-4" }, [
                  _c("div", { staticClass: "number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.allAreasScore) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "description svg-line" },
                    [
                      _c("diamond", { staticClass: "svg-icon" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("AREA_CHOOSER_TOTAL_SCORE")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "areas-list row" }, [
        _c(
          "h3",
          {
            staticClass:
              "col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2",
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("AREA_CHOOSER_LIST")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2",
          },
          _vm._l(_vm.allAreasProgressSorted, function (areaProgress) {
            return _c(
              "div",
              {
                key: areaProgress.id,
                staticClass: "card",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("div", { staticClass: "row area-specific-part" }, [
                  _c("div", { staticClass: "col-xs-8 area-chooser-details" }, [
                    _c("div", { staticClass: "area-name-row" }, [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.area(areaProgress.id).name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "area-description-row" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.area(areaProgress.id).description) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "area-chooser-row" },
                      [
                        _c("progress-bar", {
                          attrs: {
                            percent: _vm.areaProgressPercent(
                              _vm.area(areaProgress.id)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "button-and-incomplete" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn primary-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.goToArea(areaProgress.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.areaProgressPercent(
                                      _vm.area(areaProgress.id)
                                    ) === 0
                                      ? _vm.$t("BEGIN")
                                      : _vm.areaProgressPercent(
                                          _vm.area(areaProgress.id)
                                        ) === 100
                                      ? _vm.$t("VIEW_AGAIN")
                                      : _vm.$t("CONTINUE")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.areaIncompleteCount(_vm.area(areaProgress.id)) > 0
                            ? _c(
                                "div",
                                { staticClass: "incomplete-count" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.areaIncompleteCount(
                                          _vm.area(areaProgress.id)
                                        )
                                      ) +
                                      "x\n                  "
                                  ),
                                  _c("exclamation-rectangle", {
                                    staticClass: "svg-icon",
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-4" }, [
                    _c("div", { staticClass: "area-chooser-image" }, [
                      _c("img", {
                        staticClass: "img img-responsive",
                        attrs: { src: _vm.area(areaProgress.id).image },
                      }),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }